module.exports = __webpack_public_path__ + "static/media/visual-spec.dfeb6376.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/visual-spec.scss
// module id = 2133
// module chunks = 0